import { CanActivate, } from '@angular/router';
import { AuthenticationFacade } from '../+state';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthenticationTokenGuard implements CanActivate {
  public currentRoute: string;
  constructor(private authenticationFacade: AuthenticationFacade) {}

  public canActivate(): Observable<boolean> {
    return this.authenticationFacade.getAuthenticationToken().pipe(
      map((authToken) => !!authToken),
      catchError((error) => {
        this.authenticationFacade.logoutSuccess();
        return of(false);
      })
    );
  }
 

}
